import { render, staticRenderFns } from "./transactionsList.vue?vue&type=template&id=6d094e0e&scoped=true"
import script from "./transactionsList.vue?vue&type=script&lang=js"
export * from "./transactionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d094e0e",
  null
  
)

export default component.exports